(() => {
  const nav = document.querySelector('[data-pm-mobile-nav]');
  if (!nav || nav.dataset.ready === 'true') return;
  nav.dataset.ready = 'true';
  const page = document.documentElement;
  const body = document.body;
  const mobile = matchMedia('(max-width: 749px)');
  const account = nav.querySelector('[data-pm-mobile-account]');
  const accountTrigger = account && account.querySelector('summary');
  const cartLink = nav.querySelector('[data-pm-mobile-cart]');
  const garageButton = nav.querySelector('[data-pm-mobile-garage]');
  const chatButton = nav.querySelector('[data-pm-mobile-chat]');
  const chatStatus = nav.querySelector('[data-pm-chat-status]');
  const chatMessage = nav.querySelector('[data-pm-chat-message]');
  const chatContact = chatStatus && chatStatus.querySelector('a');
  const chatUnread = nav.querySelector('[data-pm-mobile-chat-unread]');
  const cartBadge = nav.querySelector('[data-pm-mobile-cart-count]');
  const garageBadge = nav.querySelector('[data-pm-mobile-garage-count]');
  const chatName = chatButton.textContent.trim();
  const cartName = cartLink.textContent.trim().replace(/^\d+\s*/, '');
  const garageName = garageButton.textContent.trim();
  const watched = new WeakSet();
  let frame = 0;
  let discoveryTimer = 0;
  let discoveryAttempts = 0;
  let pendingTimer = 0;
  let pendingUntil = 0;
  let activationSent = false;
  let chatActivator = null;
  let chatRoot = null;
  let chatIndicator = null;
  let previousChatOpen = false;
  let returnChatFocus = false;
  let sticky = null;
  const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;

  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }

  function watch(element, options) {
    if (!element || watched.has(element)) return;
    watched.add(element);
    new MutationObserver(schedule).observe(element, options);
  }

  function syncBadge(badge, control, source, label, template, clearWhenMissing = false) {
    if (!badge || (!source && !clearWhenMissing)) return;
    const count = source ? Math.max(0, parseInt(source.textContent, 10) || 0) : 0;
    const text = count > 99 ? '99+' : String(count);
    if (badge.textContent !== text) badge.textContent = text;
    badge.hidden = count === 0;
    const accessibleName = count ? label + ', ' + template.replace('__count__', String(count)) : label;
    if (control.getAttribute('aria-label') !== accessibleName) control.setAttribute('aria-label', accessibleName);
    watch(source, {childList: true, characterData: true, subtree: true});
  }

  function closeAccount(restoreFocus) {
    if (!account || !account.open) return;
    account.open = false;
    body.removeAttribute('data-pm-mobile-account-open');
    if (restoreFocus) accountTrigger.focus({preventScroll: true});
  }

  function showChatStatus(state) {
    if (!chatStatus) return;
    chatStatus.hidden = !state;
    if (state === 'loading') chatButton.setAttribute('aria-busy', 'true');
    else chatButton.removeAttribute('aria-busy');
    if (state) chatMessage.textContent = chatButton.dataset[state === 'loading' ? 'loadingMessage' : 'unavailableMessage'];
    if (chatContact) chatContact.hidden = state !== 'unavailable';
  }

  function clearPending() {
    pendingUntil = 0;
    activationSent = false;
    clearTimeout(pendingTimer);
    pendingTimer = 0;
  }

  function findChat() {
    if (chatActivator && chatActivator.isConnected) return true;
    const host = document.querySelector('shopify-chat');
    const hostRoot = host && host.shadowRoot;
    watch(hostRoot, {childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded', 'aria-hidden', 'hidden', 'open', 'class', 'style']});
    const runtime = hostRoot && hostRoot.querySelector('shopify-agent-runtime');
    chatRoot = (runtime && runtime.shadowRoot) || hostRoot;
    watch(chatRoot, {childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded', 'aria-hidden', 'hidden', 'open', 'class', 'style']});
    // The exported activator is the native launcher. Its surrounding layout is not part of our navigation.
    chatActivator = chatRoot && chatRoot.querySelector('[part~="activator"]');
    chatIndicator = chatRoot && chatRoot.querySelector('.activator__indicator');
    return !!chatActivator && typeof chatActivator.click === 'function';
  }

  function chatIsOpen() {
    return !!chatActivator && (chatActivator.getAttribute('aria-expanded') === 'true' || !!(chatRoot && chatRoot.querySelector('dialog[open]')));
  }

  function discoverChat() {
    clearTimeout(discoveryTimer);
    discoveryTimer = 0;
    if (findChat()) { discoveryAttempts = 0; schedule(); return; }
    // Discovery is bounded; a later tap always starts a fresh attempt.
    if (discoveryAttempts++ < 40) discoveryTimer = setTimeout(discoverChat, 500);
  }

  function tryPendingChat() {
    pendingTimer = 0;
    if (!pendingUntil) return;
    if (!mobile.matches || otherOverlayOpen() || resultFiltersOpen() || (account && account.open)) {
      clearPending(); showChatStatus(''); return;
    }
    const ready = findChat() && !chatActivator.disabled;
    if (ready && !activationSent) {
      activationSent = true;
      returnChatFocus = true;
      // Forward directly in the user's click handler whenever the launcher is ready.
      // No transparent overlay, coordinate tracking, or deferred first click.
      chatActivator.click();
    }
    if (chatIsOpen()) {
      clearPending(); showChatStatus(''); schedule(); return;
    }
    if (Date.now() >= pendingUntil) {
      clearPending(); showChatStatus('unavailable'); schedule(); return;
    }
    pendingTimer = setTimeout(tryPendingChat, 150);
    schedule();
  }

  function resultFiltersOpen() {
    if (page.classList.contains('pmc-vps-panel-open')) return true;
    const overlay = document.getElementById('pmgrFilterOverlay');
    if (overlay && overlay.classList.contains('is-open') && !overlay.closest('[hidden]')) return true;
    const panel = document.getElementById('pmgrControlPanel');
    if (!panel || panel.closest('[hidden]')) return false;
    const style = getComputedStyle(panel);
    return style.position === 'fixed' && style.display !== 'none' && style.visibility !== 'hidden';
  }

  function keyboardOpen() {
    const active = document.activeElement;
    const editable = active && (active.matches('input,textarea,[contenteditable="true"]'));
    return !!editable && !!window.visualViewport && window.innerHeight - window.visualViewport.height > 120;
  }

  function otherOverlayOpen() {
    const drawer = document.getElementById('Details-menu-drawer-container');
    const search = document.getElementById('PMSS');
    const mobileSearch = search && search.querySelector('[data-pmss-mobile]');
    return body.matches('.pm-garage-modal-open,.pmcd-open') || !!(drawer && drawer.open) || !!(mobileSearch && !mobileSearch.hidden);
  }

  function update() {
    frame = 0;
    const cartIcon = document.getElementById('cart-icon-bubble');
    const cartCount = document.querySelector('#cart-icon-bubble .pmcd__icon-count, #cart-icon-bubble .cart-count-bubble [aria-hidden]');
    syncBadge(cartBadge, cartLink, cartCount, cartName, nav.dataset.cartCountLabel, !!cartIcon);
    watch(cartIcon, {childList: true, characterData: true, subtree: true});
    syncBadge(garageBadge, garageButton, document.getElementById('pmGarageHeaderCount'), garageName, nav.dataset.garageCountLabel);
    const headerGarage = document.getElementById('pmGarageHeaderButton');
    if (headerGarage && headerGarage.title) garageButton.title = headerGarage.title;
    const ready = findChat();
    const chatOpen = chatIsOpen();
    body.toggleAttribute('data-pm-mobile-chat-ready', mobile.matches && ready);
    body.toggleAttribute('data-pm-mobile-chat-open', mobile.matches && chatOpen);
    chatButton.setAttribute('aria-expanded', String(chatOpen));
    if (chatOpen) { showChatStatus(''); clearPending(); }
    const unreadStyle = chatIndicator && getComputedStyle(chatIndicator);
    const unread = !!unreadStyle && !chatIndicator.hidden && chatIndicator.getAttribute('aria-hidden') !== 'true' && unreadStyle.display !== 'none' && parseFloat(unreadStyle.opacity) > 0;
    if (chatUnread) chatUnread.hidden = !unread;
    chatButton.setAttribute('aria-label', unread ? (chatButton.dataset.unreadLabel || chatName) : chatName);
    const drawer = document.getElementById('Details-menu-drawer-container');
    const blocked = otherOverlayOpen();
    const filtersOpen = mobile.matches && resultFiltersOpen();
    body.toggleAttribute('data-pm-mobile-filter-open', filtersOpen);
    body.toggleAttribute('data-pm-mobile-keyboard-open', mobile.matches && keyboardOpen());
    if (blocked || filtersOpen || chatOpen || !mobile.matches) closeAccount(false);
    if (blocked || filtersOpen) { clearPending(); showChatStatus(''); }
    if (previousChatOpen && !chatOpen && returnChatFocus) {
      returnChatFocus = false;
      if (mobile.matches && !blocked && !filtersOpen) chatButton.focus({preventScroll: true});
    }
    previousChatOpen = chatOpen;
    if (!mobile.matches) { clearPending(); showChatStatus(''); }
    const nextSticky = document.querySelector('[data-pmpp-purchase-ux] [data-pmpp-mobile-sticky]');
    if (nextSticky !== sticky) {
      if (sticky && resizeObserver) resizeObserver.unobserve(sticky);
      sticky = nextSticky;
      if (sticky && resizeObserver) resizeObserver.observe(sticky);
      watch(sticky, {attributes: true, attributeFilter: ['class', 'hidden']});
    }
    const visibleSticky = mobile.matches && sticky && sticky.classList.contains('is-visible') && !blocked && !filtersOpen && !chatOpen && !(account && account.open);
    const purchaseHeight = visibleSticky ? Math.ceil(sticky.getBoundingClientRect().height) + 6 : 0;
    const height = purchaseHeight + 'px';
    if (page.style.getPropertyValue('--pm-mobile-purchase-height') !== height) page.style.setProperty('--pm-mobile-purchase-height', height);
    watch(drawer, {attributes: true, attributeFilter: ['open']});
    watch(document.getElementById('PMSS'), {attributes: true, attributeFilter: ['aria-hidden']});
    ['pmgrFilterOverlay', 'pmgrControlPanel'].forEach(id => watch(document.getElementById(id), {attributes: true, attributeFilter: ['class', 'hidden']}));
  }

  if (account) {
    account.addEventListener('toggle', () => {
      body.toggleAttribute('data-pm-mobile-account-open', account.open);
      if (account.open) { clearPending(); showChatStatus(''); }
      schedule();
    });
    const close = account.querySelector('[data-pm-account-close]');
    if (close) close.addEventListener('click', () => closeAccount(true));
    document.addEventListener('pointerdown', event => {
      if (!account.contains(event.target)) closeAccount(false);
    });
    document.addEventListener('focusin', event => {
      if (!account.contains(event.target)) closeAccount(false);
      schedule();
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && account.open) { event.preventDefault(); closeAccount(true); }
    });
  }
  chatButton.addEventListener('click', event => {
    // Inbox closes on outside clicks. Do not let the original navigation click
    // reach that listener after the forwarded launcher click has opened it.
    event.stopPropagation();
    closeAccount(false);
    clearPending();
    pendingUntil = Date.now() + 8000;
    showChatStatus('loading');
    tryPendingChat();
  });
  watch(body, {attributes: true, attributeFilter: ['class']});
  watch(page, {attributes: true, attributeFilter: ['class']});
  mobile.addEventListener('change', schedule);
  window.addEventListener('resize', schedule, {passive: true});
  if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule, {passive: true});
  window.addEventListener('pageshow', () => { discoveryAttempts = 0; discoverChat(); schedule(); });
  ['pm:cart-updated', 'cart:updated', 'cart:change', 'cart:added', 'pm:vehicle-changed'].forEach(name => document.addEventListener(name, schedule));
  if (window.customElements) ['shopify-chat', 'shopify-agent-runtime'].forEach(name => customElements.whenDefined(name).then(discoverChat));
  discoverChat();
  schedule();
})();
